export const ShiftType = {
  Morning: "Morning",
  Evening: "Evening",
  All: "All",
};
